import { PageTitle } from "Components/Titles";
import { ReadAccount } from "Features/Account";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

function AccountDetail () {

    const { t } = useTranslation();

    return (
        <Container className="page">

            <PageTitle title={t("pages.accountDetail")} />
            <ReadAccount />

        </Container>
    );
}

export default AccountDetail;